import { useCallback } from 'react';

import { useStreetViewService } from './useStreetViewService.ts';

export const useLocationHasStreetView = () => {
  const streetViewService = useStreetViewService();

  const locationHasStreetView = useCallback(
    async (location?: google.maps.LatLngLiteral): Promise<boolean> => {
      if (!streetViewService) return false;
      if (!location) return false;

      try {
        const response = await streetViewService.getPanorama({
          location,
          radius: 30,
        });

        if (response) return true;

        console.warn(`No street view found for ${location.lat}, ${location.lng}`);
        return false;
      } catch {
        return false;
      }
    },
    [streetViewService],
  );

  if (!streetViewService) return undefined;

  return locationHasStreetView;
};
